<template>
  <div v-if="pagination.page_index < pagination.total_page && pagination.total_count" class="flex justify-center mt-14">
    <el-button :class="$style.load__btn" @click="$emit('onLoadMore')" :loading="isLoading">查看更多信息</el-button>
  </div>
</template>

<script>
export default {
  name: 'FrontPcLoadingMoreBtn',

  props: {
    pagination: Object,
    isLoading: Boolean,
  },

  data() {
    return {

    };
  },

};
</script>

<style lang="scss" module>
.load__btn {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  --tw-border-opacity: 1;
  border-color: rgba(31, 33, 41, var(--tw-border-opacity));
  border-radius: 0.25rem;
  height: 44px;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  width: 218px;
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
}
.load__btn:hover, .load__btn:focus, .load__btn:active {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  --tw-border-opacity: 1;
  border-color: rgba(31, 33, 41, var(--tw-border-opacity));
  opacity: 0.95;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
</style>